/**
* @Author: zachalam
* @Date:   2017-01-25T11:42:03-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-25T11:42:03-08:00
*/


import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import { connect } from 'react-redux';
import { logoutUserAction } from '../actions/authActions';
import { clearEverything } from '../actions/commonActions';

class LogoutContainer extends Component {

  componentWillMount() {
    // just redirect user to login where store is cleared.
    browserHistory.push("/login?logged_out=true");
  }

  render() {
    return (
      <div></div>
    );
  }
}


const mapDispatchToProps = (dispatch, ownProps) => {
  return {

    /*

    logOutUser: () => {

      browserHistory.push("/login");


      dispatch(logoutUserAction())

        .then(() => {
          // redirect user to login
          dispatch(clearEverything());
          localStorage.clear();
        })
        .catch(() => {
          dispatch(clearEverything());
          localStorage.clear();
        });


    }

    */
  }
}

export default connect(null,mapDispatchToProps)(LogoutContainer);



// WEBPACK FOOTER //
// ./src/containers/LogoutContainer.jsx